import { combineReducers } from 'redux';
import {
  ADD_MULTIPLE_EQUIPMENT_AND_POINTS,
  REMOVE_MULTIPLE_EQUIPMENT,
  DELETE_ALL_EQUIPMENT,
  DELETE_MULTIPLE_LOCATIONS,
} from '../actions/actiontypes';
import { groupListByProperty, mapValues } from '../../utils/collections';

function addOrUpdateEquipment(state, equipments) {
  // return the state with the multiple equip added/replaced
  const newState = { ...state };
  for (let i = 0; i < equipments.length; i += 1) {
    const equipment = equipments[i];
    // note: this is brittle, should change the API to always return point ids
    const pointIds = equipment.points
      ? equipment.points.map((p) => p.id)
      : newState[equipment.id]?.pointIds || [];
    newState[equipment.id] = {
      ...state[equipment.id],
      pointIds,
      ...equipment,
      buildingId: equipment.building_id,
      equipId: equipment.equip_id,
      equipmentTypeId: equipment.equipment_type_id,
      sourceEquip: equipment.source_equip,
      targetEquip: equipment.target_equip,
      equipmentRelationships: equipment.equipment_relationships,
      locationRelationships: equipment.location_relationships,
    };
  }
  return newState;
}

function removeEquipment(state, equipmentIds = []) {
  const newState = { ...state };
  for (let i = 0; i < equipmentIds.length; i += 1) {
    delete newState[equipmentIds[i]];
  }
  return newState;
}

function removeEquipmentLocations(state, buildingId, locationsDeleted) {
  const newState = { ...state };
  Object.keys(newState).forEach((key) => {
    const equip = newState[key];
    if (equip.buildingId === buildingId) {
      const newFeedsLocations = equip.feeds_locations.filter(
        (loc) => !locationsDeleted.includes(loc)
      );
      if (
        newFeedsLocations.length !== equip.feeds_locations.length ||
        locationsDeleted.includes(equip.contained_by_location)
      ) {
        const newEquip = { ...equip };
        if (locationsDeleted.includes(equip.contained_by_location)) {
          newEquip.contained_by_location = null;
        }
        newEquip.feeds_locations = newFeedsLocations;
        newState[key] = newEquip;
      }
    }
  });
  return newState;
}

function equipmentById(state = {}, action) {
  switch (action.type) {
    case DELETE_ALL_EQUIPMENT:
      return {};
    case ADD_MULTIPLE_EQUIPMENT_AND_POINTS:
      return addOrUpdateEquipment(state, action.equipment);
    case REMOVE_MULTIPLE_EQUIPMENT:
      return removeEquipment(state, action.equipmentIds);
    case DELETE_MULTIPLE_LOCATIONS:
      return removeEquipmentLocations(state, action.buildingId, action.locations_deleted);
    default:
      return state;
  }
}

function allEquipmentIds(state = [], action) {
  switch (action.type) {
    case DELETE_ALL_EQUIPMENT:
      return [];
    case ADD_MULTIPLE_EQUIPMENT_AND_POINTS:
      return state.concat(action.equipment.map((e) => e.id));
    case REMOVE_MULTIPLE_EQUIPMENT:
      return state.filter((eid) => !action.equipmentIds.includes(eid));
    default:
      return state;
  }
}

const byBuilding = (state = {}, action) => {
  switch (action.type) {
    case DELETE_ALL_EQUIPMENT:
      return {};
    case ADD_MULTIPLE_EQUIPMENT_AND_POINTS: {
      const updates = mapValues(groupListByProperty('building_id', action.equipment), (es) =>
        es.map((e) => e.id)
      );
      return { ...state, ...updates };
    }
    case REMOVE_MULTIPLE_EQUIPMENT: {
      const newState = { ...state };
      newState[action.buildingId] = newState[action.buildingId]?.filter((eid) =>
        action.equipmentIds.includes(eid)
      );
      return newState;
    }
    default:
      return state;
  }
};

// A reducer function which describes how the application state tree
// should be updated in response to equipment actions
// (for the equipment 'slice'of the tree)
const equipmentReducer = combineReducers({
  byId: equipmentById,
  allIds: allEquipmentIds,
  byBuilding,
});

export default equipmentReducer;
